/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetQuickLinksModel,
  IGetQuickLinksRequest,
  IMappers,
  IGetQuickLinksResponse,
  IGetQuickLinksResponseError,
  TGetQuickLinksResponse,
} from './types';

const defaultConfig: TGetQuickLinksModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/get-quick-links/',
  hostType: 'api',
} as TGetQuickLinksModel;

function createGetQuickLinksModel(parameters: IGetQuickLinksRequest): TGetQuickLinksModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetQuickLinksOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetQuickLinksRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetQuickLinks<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetQuickLinksOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetQuickLinksResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetQuickLinksModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetQuickLinksResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetQuickLinksResponseError);
    }
  }

  return { response, statusCode } as TGetQuickLinksResponse;
}

export { defaultConfig, createGetQuickLinksModel, fetchGetQuickLinks };
